import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import TableTextField from './TableTextField';
import { Fragment } from 'react';

export default function ChildInformation({ form, editable, cellHeader, cellInput }) {
  return (
    <TableContainer>
      <Table>
        <TableBody>
          {form?.childrens?.length > 0 ? (
            <>
              {form?.childrens?.map((row, index) => (
                <Fragment key={index}>
                  <TableRow>
                    <TableCell sx={{ ...cellHeader, width: 25, textAlign: 'center' }} rowSpan={2}>
                      {index + 1}
                    </TableCell>
                    <TableCell sx={cellInput}>
                      <TableTextField
                        name='given_name'
                        value={row.given_name}
                        placeholder='Given Name'
                        editable={editable}
                      />
                    </TableCell>
                    <TableCell sx={cellInput}>
                      <TableTextField
                        name='middle_name'
                        value={row.middle_name}
                        placeholder='Middle Name'
                        editable={editable}
                      />
                    </TableCell>
                    <TableCell sx={cellInput}>
                      <TableTextField
                        name='surname'
                        value={row.surname}
                        placeholder='Surname'
                        editable={editable}
                      />
                    </TableCell>
                    <TableCell sx={cellInput}>
                      <TableTextField
                        type='text'
                        name='dob'
                        value={row.dob}
                        placeholder='Date of Birth'
                        editable={editable}
                        hideable
                      />
                    </TableCell>
                    <TableCell sx={cellInput}>
                      <TableTextField
                        type='text'
                        name='age'
                        value={form.age}
                        placeholder='Age'
                        editable={editable}
                      />
                    </TableCell>
                  </TableRow>
                  {/*  */}
                  <TableRow>
                    <TableCell sx={cellInput} colSpan={2}>
                      <TableTextField
                        name='occupation'
                        value={row.occupation}
                        placeholder='Occupation'
                        editable={editable}
                      />
                    </TableCell>
                    <TableCell sx={cellInput} colSpan={2}>
                      <TableTextField
                        name='specialty'
                        value={row.specialty}
                        placeholder='Specialty (If MD)'
                        editable={editable}
                      />
                    </TableCell>
                    <TableCell sx={cellInput}>
                      <TableTextField
                        name='school_hospital'
                        value={row.school_hospital}
                        placeholder='School/Hospital'
                        editable={editable}
                      />
                    </TableCell>
                  </TableRow>
                </Fragment>
              ))}
            </>
          ) : (
            <TableRow>
              <TableCell colSpan='100%' sx={{ textAlign: 'center' }}>
                NO DATA FOUND
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
